export default "__VITE_ASSET__BvYP_WyD__"